module.exports = __webpack_public_path__ + "2242ae79ef1f0e457bd43f1a779461b2.svg";